import React from 'react';
import { withSessionSsr, getPublicToken } from "../../../lib/sessionMiddleware";
import { getCanonicalPath } from "../../../lib/canonical";
import { GrillaProductosSEO } from '../../../components';

const NovedadesPage = (props) => {

  const productosIniciales = props.pageProps.productosIniciales;

  const schema = [
    {
      "@context": "https://schema.org",
      "@type": "ItemList",
      "itemListElement": productosIniciales.map((p, i) => ({
        "@type": "ListItem",
        "position": i + 1,
        "url": `${process.env.NEXT_PUBLIC_URL_FRONTEND}/productos/${p.attributes.slug}`,
        "name": p.attributes.nombre,
      })),
    },
    {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": [
        { "@type": "ListItem", "position": 1, "name": "Inicio", "item": process.env.NEXT_PUBLIC_URL_FRONTEND },
        { "@type": "ListItem", "position": 2, "name": "Novedades", "item": `${process.env.NEXT_PUBLIC_URL_FRONTEND}/productos/novedades` },
      ],
    },
  ];

  return (
    <GrillaProductosSEO
      title="Novedades"
      description="Descubrí los productos más nuevos de We Celebrate: cotillón recién agregado a la tienda, listo para tu próxima fiesta."
      h1="Novedades"
      intro="¡Conocé los productos más nuevos!"
      path={props.pageProps.pathname}
      schema={schema}
      breadcrumb={[
        { label: 'Inicio', href: '/' },
        { label: 'Novedades' },
      ]}
      productosIniciales={productosIniciales}
      totalPagesIniciales={props.pageProps.totalPagesIniciales}
      totalResultsIniciales={props.pageProps.totalResultsIniciales}
      filtroFijo={{ novedad: true }}
    />
  );
};

export default NovedadesPage;

export const getServerSideProps = withSessionSsr(
  async function getServerSideProps(ctx) {

    const { req } = ctx;

    const publicToken = await getPublicToken(req);

    const fetchProductosIniciales = async () => {
      try {
        const body = {
          liviano: true,
          page: 1,
          pageSize: 24,
          novedad: true,
        };
        const result = await fetch(`${process.env.NEXT_PUBLIC_URL_FRONTEND}/api/productos/get-filtered`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'x-spiral-secret': process.env.SPIRAL_SECRET
          },
          body: JSON.stringify(body),
        });
        let data = await result.json();
        return {
          productos: data?.data || [],
          totalPages: Math.ceil((data?.meta?.pagination?.total || 0) / 24),
          totalResults: data?.meta?.pagination?.total || 0,
        };
      } catch (err) {
        console.log("e", err);
        return { productos: [], totalPages: 0, totalResults: 0 };
      }
    };

    const productosIniciales = await fetchProductosIniciales();

    return {
      props: {
        pathname: getCanonicalPath(req),
        productosIniciales: productosIniciales.productos,
        totalPagesIniciales: productosIniciales.totalPages,
        totalResultsIniciales: productosIniciales.totalResults,
      },
    };

  },
);
